export { default as ArrowIcon } from "./svg/arrow.svg";
export { default as AutomateIcon } from "./svg/automate-icon.svg";
export { default as BackArrowIcon } from "./svg/back-arrow-icon.svg";
export { default as CollaborateIcon } from "./svg/collaborate-icon.svg";
export { default as CompliantIcon } from "./svg/compliant-icon.svg";
export { default as EyeIcon } from "./svg/eye-icon.svg";
export { default as EyeSlashIcon } from "./svg/eye-slash.svg";
export { default as FerretIcon } from "./svg/ferret-icon.svg";
export { default as HamburgerIcon } from "./svg/hamburger-icon.svg";
export { default as LogoutIcon } from "./svg/logout-icon.svg";
export { default as MailIcon } from "./svg/mail-icon.svg";
export { default as TimeIcon } from "./svg/time-icon.svg";

export { default as CoinIcon } from "./svg/coin-icon.svg";
export { default as GoogleLogoIcon } from "./svg/google-logo.svg";
